import type { ReactNode } from 'react';
import { isNumber } from '@alfa-bank/site-invest-emitents-common/helpers';

export interface ICreateArrayWithCustomElement<T, S, F> {
    array: S[];
    customElement?: T;
    customElementPosition?: number;
    mapFn: F;
}

/** Вставляет в массив кастомный элемент */
export const createArrayWithCustomElement = <T, S, R extends ReactNode, F extends (value: S) => R>({
    array,
    customElement,
    customElementPosition,
    mapFn,
}: ICreateArrayWithCustomElement<T, S, F>): Array<T | R> => {
    if (customElement && isNumber(customElementPosition)) {
        if (customElementPosition === 0) {
            return [customElement, ...array.map(mapFn)];
        }

        if (customElementPosition > 0 && customElementPosition < array.length) {
            return [
                ...array.slice(0, customElementPosition).map(mapFn),
                customElement,
                ...array.slice(customElementPosition).map(mapFn),
            ];
        }

        return [...array.map(mapFn), customElement];
    }

    return array.map(mapFn);
};
